import { models, Page, Report } from 'powerbi-client';

import React, { useRef } from 'react';
import DropdownField from '../../../../components/DropdownField';
import { appInsights } from '../../../../App';
import { VISUAL_IDS } from '../../../../constants/slicers';

const SetPicker = ({
  reportRef1,
  reportRef2,
  setNames,
  setExternalSelected,
  selectedSet,
}: {
  reportRef1: React.MutableRefObject<Report | null>;
  reportRef2: React.MutableRefObject<Report | null>;
  setNames: string[];
  setExternalSelected: (name: string) => void;
  selectedSet: string;
}) => {
  const updateSet = async (name: string) => {
    setExternalSelected(name);

    appInsights.trackEvent({
      name: 'ChooseSet',
      properties: {
        name: name,
      },
    });

    if (!reportRef1.current || !reportRef2.current) {
      console.error('Report container not found.');
      return;
    }

    const report1 = reportRef1.current;
    const report2 = reportRef2.current;
    if (!report1 || !report2) {
      console.error('Report not found.');
      return;
    }

    try {
      const pages1: Page[] = await report1.getPages();
      const pages2: Page[] = await report2.getPages();
      let activePages1 = pages1.filter((page: Page) => page.isActive);
      let activePages2 = pages2.filter((page: Page) => page.isActive);

      for (const page of [...activePages1, ...activePages2]) {
        const visuals = await page.getVisuals();
        for (const visual of visuals) {
          if (visual.type === 'slicer') {
            try {
              if (visual.name === VISUAL_IDS.SET_ENABLED.REPORT1 || visual.name === VISUAL_IDS.SET_ENABLED.REPORT2) {
                try {
                  const basicFilter: models.ISlicerFilter = {
                    $schema: 'http://powerbi.com/product/schema#basic',
                    filterType: 1,
                    operator: 'In',
                    requireSingleSelection: false,
                    target: {
                      table: 'Calculation Method_blended',
                      column: 'Status',
                    },
                    values: [name === '' ? 'Off' : 'On'],
                  };

                  visual.setSlicerState({
                    filters: [basicFilter],
                  });
                } catch (error) {
                  console.error(error);
                }
              }

              if (visual.name === VISUAL_IDS.SET_VALUE.REPORT1 || visual.name === VISUAL_IDS.SET_VALUE.REPORT2) {
                try {
                  const basicFilter: models.ISlicerFilter = {
                    $schema: 'http://powerbi.com/product/schema#basic',
                    filterType: 1,
                    operator: 'In',
                    requireSingleSelection: false,
                    target: {
                      table: 'CustomPriceValues_blended',
                      column: 'setname',
                    },
                    values: [name],
                  };

                  visual.setSlicerState({
                    filters: [basicFilter],
                  });
                } catch (error) {
                  console.error(error);
                }
              }
            } catch (error) {
              console.error('Error setting slicer state:', error);
            }
          }
        }
      }
    } catch (error) {
      console.error('Error setting Set:', error);
    }
  };

  return (
    <DropdownField
      values={setNames}
      onUpdate={updateSet}
      placeholder="Select adjustment set"
      initialValue={selectedSet}
      canClear={true}
    />
  );
};

export default SetPicker;
